import React, { useContext, useEffect } from 'react'
import cx from 'classnames'
import PropTypes from 'prop-types'
import { noop } from 'lodash'
import * as Actions from '~/actions'
import { useAction, useModalDialog } from '~/hooks'

import { TranslationContext } from '~/contexts/TranslationContext'
import * as PT from '~/PropTypes'
import Header from '~/components/Settings/SettingsHead'
import Scrollbars from '~/components/base/Scrollbars'
import Confirmation from '~/components/base/Confirmation'
import './BaseAssetSettingsForm.scss'

const ScrollBarContainer = ({ hideScrollBar, children }) => {
  if (hideScrollBar) {
    return <>{children}</>
  }
  return (
    <Scrollbars
      className="scrollbar"
      style={{ height: 'calc(100% - 136px)' }}
    >
      {children}
    </Scrollbars>
  )
}

export default function BaseAssetSettingsForm(props) {
  const {
    type,
    className,
    title,
    description,
    children,
    hideScrollBar,
    selectedAssetsByType = {},
    onSelectSame = noop,
    selectedType,
    isMixedType,
  } = props
  const onSubmit = useAction(Actions.mainView.submitAssetSettingsForm, type)
  const onCancel = useAction(Actions.mainView.cancelAssetSettingsForm, type)
  const onDelete = useAction(Actions.timeline.deleteSelectedAssets)

  const deletionDialog = useModalDialog({
    onConfirm: onDelete,
  })

  const { t } = useContext(TranslationContext)

  useEffect(() => {
    const onKeyDown = e => {
      if (!deletionDialog.active) {
        if (e.key === 'Escape') {
          onCancel()
        }
      }
    }
    document.addEventListener('keydown', onKeyDown)
    return () => {
      document.removeEventListener('keydown', onKeyDown)
    }
  }, [ deletionDialog.active, onCancel ])

  return (
    <>
      <Header
        caption={title}
        description={description}
        type={selectedType}
        onClose={onCancel}
        onDelete={deletionDialog.open}
        onSave={onSubmit}
        onSelectSame={onSelectSame}
        isMixedType={isMixedType}
        selectedAssetsByType={selectedAssetsByType}
      />
      <ScrollBarContainer hideScrollBar={hideScrollBar}>
        <form className={cx('asset-settings', className)}>
          <If condition={deletionDialog.active}>
            <Confirmation
              onCancel={deletionDialog.cancel}
              onConfirm={deletionDialog.confirm}
              text={t('BASE_ASSETS_SETTINGS_TEXT_REMOVE_ASSETS_FROM_TIMELINE')}
            />
          </If>
          <div className="asset-settings__content">
            {children}
          </div>
        </form>
      </ScrollBarContainer>
    </>
  )
}

BaseAssetSettingsForm.defaultProps = {
  hideScrollBar: false,
  selectedAssetsByType: {},
  onSelectSame: noop,
  isMixedType: false,
  selectedType: '',
}

BaseAssetSettingsForm.propTypes = {
  type: PT.SourceFileType.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  hideScrollBar: PropTypes.bool,
  selectedAssetsByType: PropTypes.objectOf(PropTypes.string),
  onSelectSame: PropTypes.func,
  selectedType: PropTypes.string,
  isMixedType: PropTypes.bool,
}
